import { render, staticRenderFns } from "./ClausesForOffer.vue?vue&type=template&id=11560862&scoped=true"
import script from "./ClausesForOffer.vue?vue&type=script&lang=js"
export * from "./ClausesForOffer.vue?vue&type=script&lang=js"
import style0 from "./ClausesForOffer.vue?vue&type=style&index=0&id=11560862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11560862",
  null
  
)

export default component.exports